import useGame from '@monorepo/shared/src/hooks/use-game';
import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import { useEffect, useRef, useContext } from 'react';
import { InstructionButtonContext } from '../providers/InstructionsButtonProvider';

const useGameInstructions = () => {
  const [{ activityData }] = useGame();
  const [{ playInstructionFlag }, { stopInstructions }] = useContext(InstructionButtonContext);
  const [{ sounds, currentSound }, { playSoundFromState, loadAudioAssets, stopSound }] =
    useActivityAudio();

  const soundRef = useRef(currentSound);

  const playSounds = async () => {
    const instructionsHowler = Object.keys(sounds)
      ?.filter((x) => x.includes('activityInstruction'))
      ?.sort()
      ?.map((eachKey) => sounds[eachKey]);

    const instructions = Array.isArray(activityData.instructions)
      ? instructionsHowler
      : instructionsHowler.filter((howler) => howler.sound._src === activityData.instructions.src);

    for (const instruction of instructions) {
      await playSoundFromState(instruction, true);
    }
    stopInstructions();
  };

  useEffect(() => {
    soundRef.current = currentSound;
  }, [currentSound]);

  useEffect(() => {
    return () => {
      if (soundRef.current) {
        soundRef.current.stop();
        stopSound(); // updates state
      }
    };
  }, []);

  useEffect(() => {
    let instructions = activityData?.instructions;
    if (instructions) {
      if (!Array.isArray(instructions)) {
        instructions = [instructions];
      }
      const Sounds = instructions.map((instruction, index) => {
        return {
          name: `activityInstruction${index}`,
          category: 'instruction',
          src: { src: instruction.src },
        };
      });
      loadAudioAssets([...Sounds]);
    }
  }, [activityData]);

  useEffect(() => {
    if (playInstructionFlag) {
      playSounds();
    }
  }, [playInstructionFlag]);

  return { playSounds };
};

export default useGameInstructions;
